import { makeVar } from '@apollo/client'

export const userIdVar = makeVar<string>('')
